module.exports = __webpack_public_path__ + "img/title05_solgan.7cdae482.png";